function getText(el, localName) {
  // querySelector doesn't work reliably with XML namespaces; search by localName
  for (const child of el.children) {
    if (child.localName === localName) return child.textContent.trim();
  }
  return '';
}

function getChildByLocalName(el, localName) {
  for (const child of el.children) {
    if (child.localName === localName) return child;
  }
  return null;
}

function getAllByLocalName(el, localName) {
  const result = [];
  for (const child of el.children) {
    if (child.localName === localName) result.push(child);
  }
  return result;
}

function parseAdBreak(adBreakEl) {
  const timeOffset = adBreakEl.getAttribute('timeOffset') || '';

  const adSourceEl = getChildByLocalName(adBreakEl, 'AdSource');
  if (!adSourceEl) return null;

  const adTagURIEl = getChildByLocalName(adSourceEl, 'AdTagURI');
  const vastAdDataEl = getChildByLocalName(adSourceEl, 'VASTAdData');

  const adSource = {};

  if (adTagURIEl) {
    adSource.adTagURI = { uri: adTagURIEl.textContent.trim() };
  }

  if (vastAdDataEl) {
    // Keep the raw DOM node — the VAST parser will serialize and re-parse it
    adSource.vastAdData = vastAdDataEl.firstElementChild || vastAdDataEl;
  }

  return { timeOffset, adSource };
}

export function fetchVmapUrl(url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'document';
    xhr.timeout = 10000;
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const xmlDoc = xhr.responseXML;
        const vmapEl = xmlDoc && (xmlDoc.querySelector('VMAP') || xmlDoc.documentElement);
        if (!vmapEl) {
          reject(new Error('Invalid VMAP document'));
          return;
        }

        const adBreaks = getAllByLocalName(vmapEl, 'AdBreak')
          .map(parseAdBreak)
          .filter(Boolean);

        resolve({ adBreaks });
      } else {
        reject(new Error(`HTTP ${xhr.status}`));
      }
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.ontimeout = () => reject(new Error('Timeout'));
    xhr.send();
  });
}
